/* tslint:disable */
/* eslint-disable */
export enum WorkTicketPriorityEnum {
  Priority0 = 'PRIORITY_0',
  Priority1 = 'PRIORITY_1',
  Priority2 = 'PRIORITY_2',
  Priority3 = 'PRIORITY_3'
}
